import 'url-search-params-polyfill';
//import { SQLITE3_DB_PATH, migrateUp } from "./db-settings";
//import { Sequelize } from 'sequelize';

//const fs = window.require('fs');
//const sqlite3 = window.require('sqlite3').verbose()
// const log = window.require('electron-log');
import { makeAuthRequest, makeGoogleAuthRequest, refreshAuthToken } from '../../services/api';

export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const AUTHENTICATE = 'AUTHENTICATE'; //login attemp
export const AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
export const CLEAR_OLD_SESSION = 'CLEAR_OLD_SESSION';
export const CHECK_DB_SETUP_STATUS = 'CHECK_DB_SETUP_STATUS';
export const CONFIRM_DB_READY = 'CONFIRM_DB_READY';
export const CLEAR_NOTICES = 'CLEAR_NOTICES';
export const RESET_STATE = 'RESET_STATE';
export const SET_UPDATING = 'SET_UPDATING';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const ACKNOWLEDGE_SESSION_EXPIRY = 'ACKNOWLEDGE_SESSION_EXPIRY';

//Refresh the access token when it has less than this much life left
const REFRESH_THRESHOLD_MS = 60 * 60 * 1000; // 1 hour

/**
 * Decode the `exp` claim of a JWT without verifying it.
 * Returns the expiry as a JS timestamp (ms) or null if the token is not a JWT
 * (e.g. offline desktop mode), in which case it is treated as never expiring.
 */
export function getTokenExpiry(token){
	try{
		const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
		return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
	}catch(e){
		return null;
	}
}

export function isTokenExpired(token){
	const exp = getTokenExpiry(token);
	return exp !== null && Date.now() >= exp;
}

export function isTokenExpiring(token, thresholdMs = REFRESH_THRESHOLD_MS){
	const exp = getTokenExpiry(token);
	return exp !== null && Date.now() >= exp - thresholdMs;
}

export function setUpdating(status){
	return {
		type: SET_UPDATING,
		status
	};
}

export function resetState(){
	
	
	return {
		type: RESET_STATE
	};
}

export function clearNotices(){
	return {
		type: CLEAR_NOTICES
	};
}

//The database is not yet ready
export const WAIT_FOR_DATABASE_SETUP = 'WAIT_FOR_DATABASE_SETUP';


export function confirmDBReady(){
    return {
        type: CONFIRM_DB_READY
    };
}

export function clearAuthError(){
    return {
        type: CLEAR_AUTH_ERROR
    };
}

export function clearOldSession(){
	localStorage.removeItem('bodapro-user');
    return {
        type: CLEAR_OLD_SESSION,
    };
}

export function logIntoApp(userDetails){
    return {
        type: LOGIN,
        userDetails
    };
}

export function logOutOfApp(){
	localStorage.removeItem('bodapro-user');
    return {
        type: LOGOUT
    };
}

//The session could not be refreshed — log the user out and flag it so the UI can notify them
//storageKey defaults to the main app's key; standalone extension builds pass their own (`${extConfig.id}:userDetails`)
export function sessionExpired(storageKey = 'bodapro-user'){
	localStorage.removeItem(storageKey);
	return {
		type: SESSION_EXPIRED
	};
}

//The UI has shown the session-expired notice; clear the flag
export function acknowledgeSessionExpiry(){
	return {
		type: ACKNOWLEDGE_SESSION_EXPIRY
	};
}

//Persist new tokens to localStorage alongside the existing user details
function persistTokenUpdates(updates, storageKey = 'bodapro-user'){
	try{
		const stored = localStorage.getItem(storageKey);
		if(stored){
			localStorage.setItem(storageKey, JSON.stringify({ ...JSON.parse(stored), ...updates }));
		}
	}catch(e){
		console.log('persistTokenUpdates error:', e);
	}
}

/**
 * Exchange the refresh token for a new access token.
 *
 * On success the new tokens are saved to the store and localStorage.
 * If the server rejects the refresh token the session is expired (auto-logout + notice).
 * Network errors are ignored — the user keeps their session and we retry later.
 *
 * storageKey defaults to the main app's key; standalone extension builds pass their own.
 */
export function refreshSession(storageKey = 'bodapro-user'){
	return async (dispatch, getState) => {
		const { userDetails } = getState().session;
		const refresh = userDetails?.refresh;

		if(!refresh){
			dispatch(sessionExpired(storageKey));
			return false;
		}

		const data = await refreshAuthToken(refresh);

		if(data?.access){
			const updates = {
				token: data.access,
				//ROTATE_REFRESH_TOKENS returns a new refresh token — keep it
				...(data.refresh ? { refresh: data.refresh } : {})
			};
			dispatch(updateUserDetails(updates));
			persistTokenUpdates(updates, storageKey);
			return true;
		}

		if(data?.error === 'invalid'){
			dispatch(sessionExpired(storageKey));
		}

		return false;
	};
}

/**
 * Restore the session from localStorage on app start.
 *
 * - Access token still valid: log in (refresh in the background if close to expiry)
 * - Access token expired: try the refresh token first
 * - Refresh token dead too: expire the session so the UI prompts for login
 * - Token isn't a JWT (e.g. a separate-backend extension's own opaque token):
 *   getTokenExpiry can't read an `exp` claim, so it's treated as never expiring
 *   and no refresh is attempted — same fallback as offline desktop mode.
 *
 * storageKey defaults to the main app's key; standalone extension builds pass
 * their own (`${extConfig.id}:userDetails`, see AppExtension.js).
 */
export function restoreSession(storageKey = 'bodapro-user'){
	return async (dispatch) => {
		const loginInfo = localStorage.getItem(storageKey);
		if(!loginInfo) return;

		let user = null;
		try{
			user = JSON.parse(loginInfo);
		}catch(e){
			localStorage.removeItem(storageKey);
			return;
		}

		//Legacy/offline sessions have no tokens at all — restore them as-is
		if(!user?.token && !user?.refresh){
			dispatch(logIntoApp(user));
			return;
		}

		if(user?.token && !isTokenExpired(user.token)){
			dispatch(logIntoApp(user));
			if(isTokenExpiring(user.token)){
				dispatch(refreshSession(storageKey));
			}
			return;
		}

		//Access token expired (or missing) — the refresh token is the last resort
		const data = user?.refresh ? await refreshAuthToken(user.refresh) : null;
		if(data?.access){
			const updated = {
				...user,
				token: data.access,
				...(data.refresh ? { refresh: data.refresh } : {})
			};
			localStorage.setItem(storageKey, JSON.stringify(updated));
			dispatch(logIntoApp(updated));
			return;
		}

		dispatch(sessionExpired(storageKey));
	};
}

export function authenticateUser(){
    return {
        type: AUTHENTICATE
    };
}

export function markLoginAsFailed(error){
    return {
        type: AUTHENTICATION_FAILED,
        error
    };
}

/**
 * waitForDatabaseSetup
 * 
 * Wait for the database structure to be created
 * 
 * @param {type} notice
 * @returns {waitForDatabaseSetup.session-actionsAnonym$6}
 */
export function waitForDatabaseSetup(notice){
    return {
        type: WAIT_FOR_DATABASE_SETUP,
        message: notice
    };
}

export function clearSQLiteDB(){
    return (dispatch, getState) => {
		
		window.BodaAPI.clearSQLiteDB()
		
		dispatch(resetState());
	}
}
/**
 * Check if the database is ready
 */
export function checkDBSetupStatus(){
    return (dispatch, getState) => {
        
		try{ 
		
			//check if databae exists 

			
			// //Database already exists
			// if(fs.existsSync(SQLITE3_DB_PATH) ){
				
			// 	var stats = fs.statSync(SQLITE3_DB_PATH);
			// 	if(stats.size > 0 ){
			// 		dispatch(clearNotices());
			// 		return;					
			// 	}

			// }
			
			// if(fs.existsSync(SQLITE3_DB_PATH)){
			// 	fs.unlinkSync(SQLITE3_DB_PATH);
			// 	log.info(`Deleting boda-lite.sqlite3 because it's size is 0`);
			// }
			
			//@TODO: Move this logic to a different file 
			// let db = new sqlite3.Database(SQLITE3_DB_PATH);
			// db.serialize(function() {
			// 	//Create users table
			// 	db.run("CREATE TABLE users (" +
			// 		  "		first_name TEXT NOT NULL, " + 
			// 		  "		last_name TEXT NOT NULL," +
			// 		  "		other_names TEXT NOT NULL," +
			// 		  " 	email TEXT NOT NULL UNIQUE," +
			// 		  " 	password TEXT NOT NULL" +
			// 		  ")");
				
			// 	let stmt = db.prepare("INSERT INTO users " +
			// 	" (first_name, last_name, other_names, email, password)" +
			// 	" VALUES ('Expert','TelecomHall','','expert@telecomhall.net','password')," + 
			// 	" ('Boda','Lite','Bodastage','btsuser@bodastage.org','password')" 
			// 	);
				
			// 	stmt.run();
			// 	stmt.finalize();
				
			// 	//create database settings table 
			// 	db.run("CREATE TABLE databases (" +
			// 		  "		hostname TEXT NOT NULL, " + 
			// 		  "		port TEXT NOT NULL," +
			// 		  "		username TEXT NOT NULL," +
			// 		  " 	password TEXT NOT NULL," +
			// 		  " 	name TEXT NOT NULL UNIQUE," +
			// 		  " 	db_type TEXT NOT NULL" +
			// 		  ")");
					  
			// 	stmt = db.prepare("INSERT INTO databases " +
			// 	" (hostname, port, username, password, name, db_type)" +
			// 	" VALUES " +
			// 	" ('127.0.0.1','5432','bodastage','password','boda','postgresql')," + 
			// 	" ('127.0.0.1','5432','postgres','postgres','postgres','postgresql')"
			// 	);
				
			// 	stmt.run();
			// 	stmt.finalize();
				
			// 	dispatch(clearNotices());
			// });
			
		}catch(e){
			// log.log(e.toString());
			dispatch(clearNotices());
		}	
    }
}

export function attemptAuthentication(loginDetails){
    return async (dispatch, getState) => {
        dispatch(authenticateUser());

		const { email, password } = loginDetails;

		// const row = await bodapro.dbQuery(`SELECT * FROM users WHERE email = "${email}" AND password = "${password}"`);
		const data = await makeAuthRequest(email, password);
		console.log('data:', data);

		if(data){
			dispatch(logIntoApp({
				token: data.token,
				refresh: data.refresh,
				// first_name: data.first_name, 
				// username: data.username, 
				// email: data.email, 
				// other_names: data.other_names, 
				// last_name: data.last_name,
			
				...data.user
				}));

				//Save user details to local storage
				localStorage.setItem('bodapro-user', JSON.stringify({
					token: data.token,
					refresh: data.refresh,
					// first_name: data.first_name, 
					// username: data.username, 
					// email: data.email, 
					// other_names: data.other_names, 
					// last_name: data.last_name

					...data.user
				}));

		}else{
			dispatch(markLoginAsFailed("Wrong email and password! Try again."));
		}

    }
}

function getGoogleClientId(isDesktop) {
    return isDesktop
        ? (process.env.REACT_APP_GOOGLE_CLIENT_ID_DESKTOP || window.GOOGLE_CLIENT_ID_DESKTOP || window.GOOGLE_CLIENT_ID)
        : (process.env.REACT_APP_GOOGLE_CLIENT_ID || window.GOOGLE_CLIENT_ID);
}

function saveGoogleLoginSession(dispatch, data) {
    dispatch(logIntoApp({
        token: data.token,
        refresh: data.refresh,
        ...data.user
    }));

    localStorage.setItem('bodapro-user', JSON.stringify({
        token: data.token,
        refresh: data.refresh,
        ...data.user
    }));
}

async function startDesktopGoogleOAuth(clientId) {
    if (!window.bodapro?.openLink || !window.bodapro?.onGoogleOAuthCallback || !window.bodapro?.startGoogleOAuthLoopback) {
        throw new Error('unavailable');
    }

    const { redirectUri, state } = await window.bodapro.startGoogleOAuthLoopback();

    return new Promise((resolve, reject) => {
        const cleanup = () => {
            window.bodapro.stopGoogleOAuthLoopback?.();
        };

        const params = new URLSearchParams({
            client_id: clientId,
            redirect_uri: redirectUri,
            response_type: 'code',
            scope: 'openid email profile',
            access_type: 'offline',
            prompt: 'select_account',
            state,
        });

        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
        let unsubscribe = () => {};

        const timeoutId = setTimeout(() => {
            unsubscribe();
            cleanup();
            reject(new Error('timeout'));
        }, 5 * 60 * 1000);

        unsubscribe = window.bodapro.onGoogleOAuthCallback(async ({ code, error }) => {
            clearTimeout(timeoutId);
            unsubscribe();
            cleanup();

            if (error || !code) {
                reject(new Error(error || 'cancelled'));
                return;
            }

            const data = await makeGoogleAuthRequest(code, 'authorization_code', redirectUri);
            if (data) {
                resolve(data);
            } else {
                reject(new Error('auth_failed'));
            }
        });

        window.bodapro.openLink(authUrl).catch((err) => {
            clearTimeout(timeoutId);
            unsubscribe();
            cleanup();
            reject(err);
        });
    });
}

async function attemptWebGoogleAuthentication(clientId, dispatch) {
    if (!window.google) {
        await loadGoogleSignInScript();
    }

    await window.google.accounts.id.initialize({
        client_id: clientId,
        callback: async (response) => {
            const data = await makeGoogleAuthRequest(response.credential);
            if (data) {
                saveGoogleLoginSession(dispatch, data);
            } else {
                dispatch(markLoginAsFailed("Google authentication failed. Please try again."));
            }
        }
    });

    window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            window.google.accounts.oauth2.initTokenClient({
                client_id: clientId,
                scope: 'openid email profile',
                callback: async (response) => {
                    if (response.error) {
                        dispatch(markLoginAsFailed("Google authentication was cancelled or failed."));
                        return;
                    }

                    const data = await makeGoogleAuthRequest(response.access_token, 'access_token');
                    if (data) {
                        saveGoogleLoginSession(dispatch, data);
                    } else {
                        dispatch(markLoginAsFailed("Google authentication failed. Please try again."));
                    }
                }
            }).requestAccessToken();
        } else if (notification.isDismissedMoment && notification.isDismissedMoment()) {
            // User dismissed One Tap — clear stuck authenticating without an error banner
            dispatch(markLoginAsFailed(""));
            setTimeout(() => dispatch(clearAuthError()), 0);
        }
    });
}

export function attemptGoogleAuthentication(){
    return async (dispatch, getState) => {
        dispatch(authenticateUser());

        try {
            const isDesktop = window.bodapro && window.bodapro.platformType === 'desktop';
            const clientId = getGoogleClientId(isDesktop);

            if (!clientId) {
                dispatch(markLoginAsFailed("Google OAuth client ID not configured."));
                return;
            }

            if (isDesktop && window.bodapro?.openLink) {
                try {
                    const data = await startDesktopGoogleOAuth(clientId);
                    saveGoogleLoginSession(dispatch, data);
                } catch (error) {
                    if (error?.message === 'timeout') {
                        dispatch(markLoginAsFailed("Google Sign-In timed out. Please try again."));
                    } else if (error?.message === 'cancelled' || error?.message === 'access_denied') {
                        dispatch(markLoginAsFailed("Google authentication was cancelled."));
                    } else {
                        dispatch(markLoginAsFailed("Google authentication failed. Please try again."));
                    }
                }
                return;
            }

            await attemptWebGoogleAuthentication(clientId, dispatch);
        } catch (error) {
            console.error('Google OAuth error:', error);
            dispatch(markLoginAsFailed("Failed to initialize Google Sign-In. Please try again."));
        }
    }
}

// Helper function to load Google Sign-In script
function loadGoogleSignInScript() {
    return new Promise((resolve, reject) => {
        if (document.getElementById('google-sign-in-script')) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.id = 'google-sign-in-script';
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

export function handleMigration(bodaProConfig = null){
	return async (dispatch, getState) => {
		//Check if the database is ready
		await bodapro.migrateUp();

		await bodapro.submitCode({
			code: "import pip\npip.main(['install', 'pandas'])",
			lang: 'python',
			config: bodaProConfig
		});

		dispatch(setUpdating(false));
	}
}

export function updateUserDetails(userDetails){
	return {
		type: UPDATE_USER_DETAILS,
		userDetails
	};
}

export default { logIntoApp, logOutOfApp, authenticateUser, attemptAuthentication, attemptGoogleAuthentication };
